import { useMutation, useQuery, useQueryClient } from "react-query";
import MetricProcess from "../pages/takeoff/layouts/processes/models/metric-process.ts";
import { fetchItem } from "../queries/queries-helper";
import ENDPOINTS from "../services/endpoints.ts";
import DashboardProcessDto, { PROCESS_DTO_MAPPING } from "../models/interfaces/dtos/dashboard-process-dto.ts";
import FlowMode from "@/models/enums/flow-mode.ts";
import { StatsProcessUpdate, updateProjectProcessStatus } from "@/services/dashboard-process";


const useDashboardProcess = (projectId: string) => {
    const queryClient = useQueryClient();
    const dashboardProcessStatusQuery = useQuery(
        ["dashboard-process-status", projectId],
        async () => await fetchItem<DashboardProcessDto>(ENDPOINTS.DASHBOARD_PROCESS_STATUS(projectId)) ?? undefined,
        {
            enabled: !!projectId,
            staleTime: 3 * 60 * 1000,
        }
    );

    const updateDashboardProcessStatus = useMutation({
        mutationFn: (update: StatsProcessUpdate) => updateProjectProcessStatus(projectId, update),
        onSuccess: async () => {
            // Les hasCalcul* sont calculés par l'API, pas déduits côté client.
            await queryClient.invalidateQueries(["dashboard-process-status", projectId], { exact: true });
        }
    });

    const applyDashboardProcessStatus = (
        metrics: MetricProcess[],
        projectFlowMode: FlowMode,
        dto?: DashboardProcessDto
    ): MetricProcess[] => {
        if (!dto) return metrics;

        return metrics.map(metric => {
            const mapping = PROCESS_DTO_MAPPING[metric.keyName];

            if (!mapping) return metric;

            return new MetricProcess(metric.keyName, projectFlowMode, {
                ...metric,
                
                is2DDone: metric.is2D && (mapping.is2D ? Boolean(dto[mapping.is2D]) : metric.is2DDone),
                is3DDone: metric.is3D && (mapping.is3D ? Boolean(dto[mapping.is3D]) : metric.is3DDone)
            });
        });
    }

    return {
        dashboardProcessStatusQuery,
        updateDashboardProcessStatus,
        applyDashboardProcessStatus
    }
}

export default useDashboardProcess;
